import * as React from "react";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { IconButton } from "@mui/material";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";

/**
 *
 * @typedef {object} DropdownFilterCellProps
 * @prop {string} defaultItem
 * @prop {string[]} data
 */

/**
 *
 * @param {DropdownFilterCellProps& DropdownFilterCellProps} props
 * @returns
 */
export const YesNoDropdownFilterCell = (props) => {
  const { t } = useTranslation();
  let hasValue = (value) => Boolean(value && value !== props.defaultItem);

  /**
   *
   * @param {DropDownListChangeEvent} event
   */
  const onChange = (event) => {
    hasValue = hasValue(event.target.value);
    props.onChange({
      value: hasValue ? event.target.value.value : "",
      operator: hasValue ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };
  const yesNoData = React.useMemo(
    () => t("yes_no_data", { returnObjects: true }),
    [t]
  );
  const onClearButtonClick = (event) => {
    event.preventDefault();
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div className="k-filtercell">
      <DropDownList
        data={yesNoData}
        dataItemKey="value"
        textField="text"
        onChange={onChange}
        value={yesNoData.find((d) => d.value === props.value) || null}
        defaultItem={props.defaultItem}
      />
      <IconButton
        disabled={!hasValue(props.value)}
        onClick={onClearButtonClick}
      >
        <FilterAltOffIcon />
      </IconButton>
    </div>
  );
};
